import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Virtual } from "swiper";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";

SwiperCore.use([Navigation, Pagination, Virtual]);

const Gallery = ({ assets, initialSlide = 0 }) => {
  return (
    <Swiper
      navigation
      pagination={{ clickable: true }}
      slidesPerView={1}
      initialSlide={initialSlide}
    >
      {assets.map((asset, index) => (
        <SwiperSlide key={index}>
          <div className="h-screen max-w-screen flex justify-center items-center">
            <img src={asset} alt="" className="object-cover" />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Gallery;
